import React from "react";
import "./Loading.scss";
const Loading = () => {
  return <div className="custom-loader" />;
};

export default Loading;
